export default "__VITE_ASSET__Cy2EZ0ts__"